export default "/_next/static/images/Scandinavian-0e8c5654886f8b0d588de1d1561960fb.png";